import Alert from '@widgets/Alert';
import { systemCode } from '@helpers/Constants';

export default function ucLogin() {
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = window.AUTH_APIS_URL + '?t=' + Date.now();
    script.async = true;
    document.body.appendChild(script);

    window.Web = {
      init() {
        const userInfo = window.UserInfo;
        delete window.UserInfo;

        if(!userInfo) {
          Alert.show('获取用户信息失败，请重试');
          reject('UC_LOGIN_USER_INFO_ERROR');
          return;
        }

        //用户信息目前需要自己拼接，以保证和微信接口返回的一致
        resolve({
          openId: '',
          roles: [],
          seewoUser: {
            idNumber: '',
            inviteCode: '',
            nickName: userInfo.cnName,
            phone: userInfo.phone,
            photoUrl: userInfo.photoUrl,
            realName: userInfo.realName,
            uid: userInfo.resourceid,
            unitId: userInfo.unitId,
            unitName: userInfo.unitName,
            username: userInfo.userName
          },
          token: userInfo.token,
          weChatUser: {},
          loginFromUC: true
        });
        delete window.Web;
      },
      authCallback() {
        Alert.show({
          title: '登录失败，请重试',
          btnEvent: () => {
            window.location.replace(window.LOGIN_URL + `?system=${systemCode }&redirect_url=` + encodeURIComponent(window.BASE_URL));
          }
        });
        reject('UC_LOGIN_ERROR');
      }
    };
  });
  return promise;
}
